module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/nakaya-1d5fd74c0712b41dca43359edaaa330f.jpg";